import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('note_this_request_is_on_ck_on_the_unlock_button'),
};
